import countries from "../data/countries";

export const findCountryPhoneCode = (countryCode: string): string | undefined => {
  const countryData = countries.find(({ shortName }) => shortName === countryCode);
  if (!countryData) {
    return undefined;
  }

  const trimmedCode = countryData.code.replace("-", "");
  return trimmedCode;
};
